import AnimatedNumber from "@/components/AnimatedNumber";
import { cn } from "@/lib/utils";

// Big, tabular result display. Primary stat + optional secondary stats.
export default function ResultStat({ label, value, secondary = [], primary = true, format, suffix, className }) {
    return (
        <div
            role="status"
            aria-live="polite"
            aria-atomic="true"
            className={cn(
                "relative overflow-hidden rounded-2xl p-8",
                primary ? "bg-primary text-primary-foreground" : "bg-card border border-border text-primary",
                className,
            )}
            data-testid="result-stat"
        >
            {primary && <div className="absolute inset-0 noise opacity-40 pointer-events-none" aria-hidden />}
            <div className="relative">
                <div
                    className={cn(
                        "font-mono tabular text-[10px] uppercase tracking-[0.2em]",
                        primary ? "text-accent-bright" : "text-muted-foreground",
                    )}
                >
                    {label}
                </div>
                <div className="font-mono tabular text-5xl lg:text-6xl mt-3 leading-none">
                    <AnimatedNumber value={Number.isFinite(value) ? value : 0} format={format} />
                    {suffix && <span className="text-2xl ml-1 opacity-70">{suffix}</span>}
                </div>
                {secondary.length > 0 && (
                    <div
                        className={cn(
                            "mt-6 pt-6 grid gap-4",
                            secondary.length === 1 ? "grid-cols-1" : "grid-cols-2",
                            primary ? "border-t border-primary-foreground/20" : "border-t border-border",
                        )}
                    >
                        {secondary.map((s) => (
                            <div key={s.label}>
                                <div
                                    className={cn(
                                        "text-[10px] uppercase tracking-widest",
                                        primary ? "text-primary-foreground/60" : "text-muted-foreground",
                                    )}
                                >
                                    {s.label}
                                </div>
                                <div className="font-mono tabular text-xl mt-1" data-testid={s.testId}>
                                    {s.format ? s.format(s.value) : s.value}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
